const colors = {
  borderOnEmpty: '#B8B7B7',
  surfaceBorder: {
    dark: '#3D3D3D',
    light: '#E8E8E8',
  },
  surface: { light: '#FAFAFA', dark: '#171717' },
  graphColors: {
    gradient1: '#069887',
    gradient2: '#BCEBE5',
    gradient3: '#D9F2EF',
  },
  reportCardHover: { light: '#EDEDF7', dark: '#190E27' },
  tooltip: { light: '#323232', dark: '#F1F0F4' },
  dataViz: {
    category1: { light: '#4D7EFF', dark: '#7A9FFF' },
    category2: { light: '#912E93', dark: '#DF66E1' },
    category5: { light: '#D85337', dark: '#EE7358' },
  },
  interactiveBorder: { light: '#C4C4C4', dark: '#4D4E4E' },
  warning: { main: '#AB5A05', subtle: '#FCE3CA', subtleContrast: '#552C07' },
};

export default colors;
